import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import api from '@/admin/lib/api'

/**
 * Whether consumers may raise their own claims. `enabled` is the tenant
 * admin's choice; `available` is false when staff have switched the
 * capability off, in which case it cannot be turned on here.
 */
export interface ConsumerClaimSettings {
  enabled: boolean
  available: boolean
}

const KEY = ['consumer-claim-settings']

export function useConsumerClaimSettings() {
  return useQuery<ConsumerClaimSettings>({
    queryKey: KEY,
    queryFn: () =>
      api.get('/organisations/consumer-claim-settings/').then((r) => r.data),
  })
}

export function useUpdateConsumerClaimSettings() {
  const qc = useQueryClient()
  return useMutation<ConsumerClaimSettings, Error, { enabled: boolean }>({
    mutationFn: (data) =>
      api
        .patch('/organisations/consumer-claim-settings/', data)
        .then((r) => r.data),
    onSuccess: (data) => {
      qc.setQueryData(KEY, data)
    },
  })
}
